/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2BackIcon24Solid = forwardRef('MediaUiASkip2BackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1.5 4A1.5 1.5 0 0 1 3 5.5v4.74l8.322-5.855C12.448 3.592 14 4.398 14 5.775v3.762l7.322-5.152C22.448 3.592 24 4.398 24 5.775v12.45c0 1.377-1.552 2.183-2.678 1.39L14 14.463v3.762c0 1.377-1.552 2.183-2.678 1.39L3 13.76V18.5a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 1 1.5 4Z" })));
});
